import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiAlertTitle: Components<Theme>['MuiAlertTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '14px',
      lineHeight: 1.5,
      color: theme.palette.common.black,
      marginTop: 0,
      marginBottom: '10px',
    }),
  },
};
